SupportMainContentWrapperView = require('../../main_content_view')
StepTwoInbentaBaseView = require('./base_view')
SupportAPIHelper = require('../../../helpers/API')
SupportErrorHelper = require('../../../helpers/error')

class StepTwoInbentaNonNLPView extends StepTwoInbentaBaseView
  initialize: ->
    StepTwoInbentaBaseView::initialize.apply(this, arguments)

  renderInbentaSearchBox: (contentWrapper)->
    return

  fetchAndRenderCategory : (contentWrapper) ->
    if @dropDownModel.has('categories')
      @renderCategory(contentWrapper)
    else
      @spinnerView.show( { container:contentWrapper, append:true, height: '50px' } )
      startTimer("t_dc")

      $.when(@dropDownModel.fetch(), @dropDownCombinationsModel.fetch()).done(
        ( model, response, options ) =>
          stopTimer("t_dc")
          @flexStepThree.dropdownCombinations = response.flexStepThree?['dropdownCombinations']
          @spinnerView.remove()
          @handleDropdownsCb(contentWrapper)
      ).fail(
        () =>
          @spinnerView.remove()
          @handleAjaxErrors()
      )

  handleDropdownsCb: (contentWrapper)->
    @renderCategory(contentWrapper)

  renderCategory: (contentWrapper)->
    isFilterDropdowns = if window.evaluate(experiments?.filterDropdowns) then true else false
    categoryArray = @getCategoryList()
    contentWrapper.append toHtml(@categoryTemplate, {categories: categoryArray, isFilterDropdowns:isFilterDropdowns }, @I18nScope)
    contentCategory = Groupon.Support.ContentModel.getCategory()
    if contentCategory && contentCategory != null
      $(".category", contentWrapper).val(contentCategory.id)
      # Adding single Quotes because the jquery selector erroring out if the id has punctuation in it
      $(".category option[value='#{contentCategory.id}']", contentWrapper).attr("selected", "selected")
      @renderSubCategory(contentWrapper)

  renderSubCategory: (contentWrapper) ->
    @disableAllButton()
    subdropdwn = $('.sub-dropdown',contentWrapper)
    subdropdwn.html("")
    subdropdwn.html toHtml(@subCategoryTemplate, {subCategories: @getSubCategoryList()}, @I18nScope)
    contentSubCategory = Groupon.Support.ContentModel.getSubCategory()
    if contentSubCategory && contentSubCategory != null
      $(".sub-category",contentWrapper).val(contentSubCategory.id)
      # Adding single Quotes because the jquery selector erroring out if the id has punctuation in it
      $(".sub-category option[value='#{contentSubCategory.id}']", contentWrapper).attr("selected", "selected")
      @fetchHelpContent(contentWrapper)

  enableResolvedButton: (event) =>
    if @flexStepThree?['allowed'] and not @flexStepThree?['responseReceived']
      return @inbentaEventType = event.type
    @isInbentaContentShown = true
    @sendTrackyCallForHelpContentBeingShown true
    @$('.issue-check').show()
    @$('.direct-ticket').hide()

  disableAllButton: ->
    @isInbentaContentShown = false
    StepTwoInbentaBaseView::disableAllButton.apply(this, arguments)

  enableTicketDirectionButton: (event) =>
    if @flexStepThree?['allowed'] and not @flexStepThree?['responseReceived']
      return @inbentaEventType = event.type
    @isInbentaContentShown = true
    @sendTrackyCallForHelpContentBeingShown false
    @$('.issue-check').hide()
    @$('.direct-ticket').show()

  setCategoryToWindow: ->
    @contentRequests = abortAjaxRequests @contentRequests
    @disableAllButton()
    if @inbentaTimeoutFn? then clearTimeout @inbentaTimeoutFn
    if @inbentaContentLoadTimeoutFn? then clearTimeout @inbentaContentLoadTimeoutFn
    category = @$('.category option:selected').val()
    addToTrackingHub(category, null)
    @clearElement('.inbenta-content')
    if category == ''
      @$(".sub-category option[value='']").attr("selected", "selected");
      @$('.sub-category').trigger('change')
      Groupon.Support.ContentModel.setCategory(null)
      Groupon.Support.ContentModel.setSubCategory(null)
      @clearElement('.sub-dropdown')
    else
      Groupon.Support.ContentModel.setCategory(
        id: @$('.category option:selected').val()
        text: @$('.category option:selected').text()
      )
      Groupon.Support.ContentModel.setSubCategory(null)
      @renderSubCategory(@$el)

  setSubCategoryToWindow: ->
    @contentRequests = abortAjaxRequests @contentRequests
    subcategory = @$('.sub-category option:selected').val()
    if @inbentaTimeoutFn? then clearTimeout @inbentaTimeoutFn
    if @inbentaContentLoadTimeoutFn? then clearTimeout @inbentaContentLoadTimeoutFn
    @disableAllButton()
    addToTrackingHub(Groupon.Support.ContentModel.getCategory().id, subcategory)

    if subcategory == ''
      Groupon.Support.ContentModel.setSubCategory(null)
      @clearElement('.inbenta-content')
    else
      Groupon.Support.ContentModel.setSubCategory(
        id: @$('.sub-category option:selected').val()
        text: @$('.sub-category option:selected').text()
      )
      @fetchHelpContent()

  fetchHelpContent: (contentWrapper)->
    if @isFlexStepThreeAllowed()
      @resetFlexStepThree()
      if contentWrapper?
        @spinnerView.show({ container:$('.inbenta-content', contentWrapper), height: '50px' })
      else
        @spinnerView.show({ container:$('.inbenta-content', @$el), height: '50px' })
      urls = @getHelpContentPaths()
      data = @getTaglines()
      @contentRequests = SupportAPIHelper.parallel urls, data, @getHelpContentSuccessCb(), @getHelpContenteErrorCb(), false, "t_ic", 60000
    else
      Groupon.Support.ContentModel.flexibleStepThree = null
      @callTimeoutFn()
    @setFlexibleContactChannels()

  helpContentSuccess: (results) =>
    Groupon.Support.ContentModel.flexibleStepThree = results[0] if results?.length? > 0
    @flexStepThree['responseReceived'] = true
    unless @inbentaEventType then return @helpContentError()
    @callInbentaEventCb()

  helpContentError: () =>
    @flexStepThree['responseReceived'] = true
    if @inbentaEventType? then return @callInbentaEventCb()
    @callTimeoutFn()

  callInbentaEventCb: () =>
    if @inbentaEventType is "help-text"
      @enableResolvedButton()
    else
      @enableTicketDirectionButton()

  callTimeoutFn: () =>
    timeoutFn = () =>
      if @isInbentaContentShown is false and @isCategoryAndSubcategorySelected()
        @helpContentLoadError()
        @enableTicketDirectionButton()
        @sendTrackyCallForHelpContentBeingShown false
        throw new Error(SupportErrorHelper.constructInbentaLoadErrorMessage())

    if @shouldHandleCbFromEmailForm() then return

    if @inbentaContentLoadTimeoutFn? then clearTimeout @inbentaContentLoadTimeoutFn
    @inbentaTimeoutFn = setTimeout(timeoutFn, 5000)

  shouldHandleCbFromEmailForm: ()->
    if $('.inbenta-content').text().length <= 1
      unless @alreadySubCategoryChangeInitiated
        @alreadySubCategoryChangeInitiated = true
        @$('.sub-category').trigger('change')
        @inbentaContentLoadTimeoutFn = setTimeout(@callTimeoutFn, 3000)
        return true

module.exports = StepTwoInbentaNonNLPView
